ixModuleRouting("impactx.account", {
    "/accountlist": {
        template: "<ixa-account-list></ixa-account-list>",
        process: "ListAccount",
        workspace: "admin",
    },
    "/account": {
        template: "<ixa-account></ixa-account>",
        process: "EditAccount",
        workspace: "admin",
    },
});
